import {liteClient} from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import {
    index,
    searchBox,
    hits,
    configure,
    stats,
    pagination,
} from 'instantsearch.js/es/widgets';
import Ready from '../utils/ready';

Ready(() => {
    let timerId;
    const timeout = 150;
    if (!document.querySelector('#treatment-search-box')) return;

    const searchField = document.querySelector('#treatment-search-box');

    const searchClient = liteClient(
        '0JIZOCPQB1',
        'f446c9efada33fa663a7039c057f610c',
    );

    const searchIndex = 'dev_primary_index';
    const search = instantsearch({
        indexName: searchIndex,
        routing: false,
        searchClient,
        insights: true,
        onStateChange({uiState, setUiState}) {
            setUiState(uiState);
        },
        searchFunction(helper) {
            if (helper.state.query) {
                helper.search();
            }
        },
    });

    const searchPage = '/search/';

    function toggleHitsVisibility(container, isVisible) {
        if (isVisible) {
            document.querySelector(container).classList.remove('hidden');
        } else {
            document.querySelector(container).classList.add('hidden');
        }
    }

    const searchResultsTreatment = (hit, {html}) =>
        html`<a
            href="${hit.url}"
            class="ais-search-result-link-wrapper ais-search-result-link-wrapper--specialist_treatments"
            data-insights-object-id="${hit.objectID}"
            data-insights-position="${hit.__position}"
            data-insights-query-id="${hit.__queryID}"
        >
            <div class="ais-search-result-body">
                <h3>${hit.title}</h3>
                <p>${hit.excerpt}</p>
            </div>
            <div class="ais-search-result-image">
                <span
                    ><svg>
                        <use
                            xlink:href="/public/svg/sprite.svg#${hit.icon}"
                        /></svg
                ></span>
            </div>
        </a>`;

    search.addWidgets([
        configure({
            hitsPerPage: 3,
            filters: 'content_type:unit',
            clickAnalytics: true,
        }),
        searchBox({
            container: searchField,
            magnifier: true,
            placeholder: 'eg. treatment or condition',
            autofocus: searchPage,
            showReset: true,
            showSubmit: true,
            showLoadingIndicator: true,
            cssClasses: {
                root: 'ais-SearchBox',
                form: 'ais-SearchBox-form',
                input: 'ais-SearchBox-input fui-input',
                submit: 'ais-SearchBox-submit',
                reset: 'ais-SearchBox-reset',
                loadingIcon: 'ais-SearchBox-loading',
            },
            reset() {
                toggleHitsVisibility(
                    '.search-results-block-specialist_units--on-page',
                    0,
                );
                toggleHitsVisibility(
                    '.search-results-block-specialist_treatments--on-page',
                    0,
                );
            },
            queryHook(query, refine) {
                clearTimeout(timerId);
                timerId = setTimeout(() => refine(query), timeout);
                toggleHitsVisibility(
                    '.search-results-block-specialist_units--on-page',
                    query.length,
                );
                toggleHitsVisibility(
                    '.search-results-block-specialist_treatments--on-page',
                    query.length,
                );
            },
        }),
        hits({
            container: '#search-box--treatments__hits-specialist_units',
            templates: {
                empty: 'No specialist units match your search',
                item: searchResultsTreatment,
            },
        }),
        index({
            indexName: searchIndex,
            indexId: 'specialist_treatments',
        }).addWidgets([
            configure({
                hitsPerPage: 12,
                filters: 'content_type:treatment',
                clickAnalytics: true,
            }),
            stats({
                container:
                    '#search-box--treatments__hits-specialist_treatments-stats',
            }),
            pagination({
                container:
                    '#search-box--treatments__pagination-specialist_treatments',
                showFirst: false,
                showLast: false,
                scrollTo: false,
            }),
            hits({
                container:
                    '#search-box--treatments__hits-specialist_treatments',
                templates: {
                    empty: 'No treatments match your search',
                    item: searchResultsTreatment,
                },
                transformItems(items, {results}) {
                    toggleHitsVisibility(
                        '#search-box--treatments__pagination-specialist_treatments',
                        results.nbHits > results.hitsPerPage,
                    );
                    toggleHitsVisibility(
                        '#search-box--treatments__hits-specialist_treatments',
                        items.length > 0,
                    );
                    return items;
                },
            }),
        ]),
    ]);

    search.start();
});
